
import React from 'react'
import PropTypes from 'prop-types';

import {Button, Classes, Dialog, FormGroup, InputGroup, Tooltip} from "@blueprintjs/core";
import connect from "react-redux/es/connect/connect";
import "./resources/css/formulariomarcaje.css"
import {estadoChangePagina, PAGE_MARCAJE, PAGE_MARCAJERESULTADO} from "./redux/estado/actions";
import {servidorImagenes, tiempoEsperaInformacionMarcaje} from "./Configuracion"
import {getFormattedDateTimeFromCadenaISO} from "../framework/DateUtils"

class FormularioMarcajeResultado extends React.Component {

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    componentDidMount() {
        setInterval(() => {
            this.props.dispatch(estadoChangePagina(PAGE_MARCAJE));
        },tiempoEsperaInformacionMarcaje*1000 );

    }



    onVolver= () =>{
        this.props.dispatch(estadoChangePagina(PAGE_MARCAJE));
    }




    render() {
        const {estado} = this.props;

        return (
            <>
                {estado.personal &&
                <div className="formulariomarcajecorrecto">
                    <img width="100" src={servidorImagenes + "nodefinido.jpg"} alt="imagen"/>
                    <div className="formulariodatos">
                        <div>{estado.personal.nombre}</div>
                        <div>{getFormattedDateTimeFromCadenaISO(estado.personal.fecha)}</div>
                        <div className="botoncentrado">
                            <Button style={{width:100}} large={true} icon="circle-arrow-left" onClick={this.onVolver}>Volver</Button>
                        </div>
                    </div>
                </div>
                }

                {!estado.personal &&
                    <div className="formulariomarcajeincorrecto">
                        <div className="formulariodatosnoencontrado"> NO ENCONTRADO</div>
                        <div className="botoncentrado">
                            <Button style={{width:100}} large={true} icon="circle-arrow-left" onClick={this.onVolver}>Volver</Button>
                        </div>
                    </div>
                }
            </>
        )
    }
}

/*
<div style={{textAlign: 'center'}} >
    <Button  large={true} icon="circle-arrow-left" onClick={this.onVolver}>Volver</Button>
</div>
 */
FormularioMarcajeResultado.propTypes = {
    nombre: PropTypes.string,
}

const mapStateToProps = function(state) {
    return {
        estado: state.estado,
    }
}


export default connect(mapStateToProps)(FormularioMarcajeResultado);
